<template>
  <div class="Sibebar">
    <div class="Sibebar__close-link" @click="toggleSidebar()">
      <IconBase iconName="close"><IconClose /></IconBase>
    </div>
    <Navigation @click="toggleSidebar()" />
  </div>
</template>

<script>
import EventBus from "../event-bus";
import Navigation from "./Navigation";
import IconClose from "./icons/IconClose";

export default {
  methods: {
    toggleSidebar: function() {
      EventBus.$emit("toggleSidebar");
    }
  },
  components: { Navigation, IconClose }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.Brand {
  margin-bottom: 2rem;
}

.Sibebar {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  background: $color-black;
  color: #fff;

  &__close-link {
    position: absolute;
    top: 0;
    right: 0;
    padding: $global-margin * 1.5;
  }

  &__cgu-link {
    margin-top: $global-margin * 2;
    text-align: center;
    color: #fff;
    font-size: 0.75rem;
  }
}

</style>
